import { React, useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";



export default function Menubar(prop) {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const navigate = useNavigate();
    const { showMenuSide, setValueMenuSideBar } = prop;

    const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
    const variantName = vehicalDetails?.variant_name;

    const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "");
    const [selectedMake, setSelectedMake] = useState(vehicalDetails ? vehicalDetails.make : "");
    const [selectedModel, setSelectedModel] = useState(vehicalDetails ? vehicalDetails.model : "");
    const [selectedVariant, setSelectedVariant] = useState(vehicalDetails ? vehicalDetails.variant : "");

    const [selectedMakeName, setSelectedMakeName] = useState(vehicalDetails ? vehicalDetails.make_name : "");
    const [selectedModelName, setSelectedModelName] = useState(vehicalDetails ? vehicalDetails.model_name : "");
    const [selectedVariantName, setSelectedVariantName] = useState(vehicalDetails ? vehicalDetails.variant_name : "");

    const [isLoading, setIsLoading] = useState(true);
    const [isLoaderMake, setIsLoaderMake] = useState(true);
    const [isLoaderModel, setIsLoaderModel] = useState(true);
    const [isLoaderVarient, setIsLoaderVarient] = useState(true);

    const [isOpenMake, setisOpenMake] = useState(false);
    const [isOpenModel, setisOpenModel] = useState(false);
    const [isOpenVarient, setisOpenVarient] = useState(false);

    const [showMake, setShowMake] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const [showVarient, setShowVarient] = useState(false);

    const makeRef = useRef(null);
    const modelRef = useRef(null);
    const variantRef = useRef(null);


    const [isActive, setIsActvie] = useState('');
    const [isValue, setIsValue] = useState('');

    const [showVehicleModal, setShowVehicleModal] = useState(false);

    const [dataYear, setDataYear] = useState([]);
    const [dataMake, setDataMake] = useState([]);
    const [dataModel, setDataModel] = useState([]);
    const [dataModelVarient, setDataVarient] = useState([]);



    const hideSideMenueBar = () => {
        setValueMenuSideBar('')
        document.body.classList.remove('home-layout');
    }

    useEffect(() => {
        fetchYearData();
    }, []);


    const handleWheelAndTirePackageClick = () => {
        emptyLocalStorage();
        const vehicle = JSON.parse(localStorage.getItem('vehical_details'));
        if (vehicle && vehicle.year && vehicle.make && vehicle.model) {
            redirectToWheelAndTirePackage();
        } else {
            setShowVehicleModal(true);
        }
    };

    const handleVehicleSearch = () => {
        document.body.classList.remove('overflow_vehicle');
        let state = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            variant: selectedVariant,
            make_name: selectedMakeName,
            model_name: selectedModelName,
            variant_name: selectedVariantName,
        };
        localStorage.setItem('vehical_details', JSON.stringify(state));
        localStorage.removeItem('wheels_details');
        setShowVehicleModal(false);
        redirectToWheelAndTirePackage();
    };


    const fetchYearData = async () => {
        setIsLoading(true);
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getYear`,
            };
            axios
                .request(config)
                .then((response) => {
                    setDataYear(response.data);
                    setIsLoading(false);
                    if (selectedYear) {
                        fetchMakeData(selectedYear);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
        }
    };

    const handleYearChange = (event) => {
        setisOpenVarient(false);
        setisOpenModel(false);
        const selectedYear = event.value;
        if (selectedYear === "") {
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            setDataMake("");
            setDataModel("");
            setDataVarient("");

            setSelectedMakeName('');
            setSelectedModelName('');
            setSelectedVariantName('');
        } else {
            setSelectedYear(selectedYear);
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            fetchMakeData(selectedYear);
            setIsLoaderMake(false);
            setShowMake(true);
            setSelectedMakeName('');
            setSelectedModelName('');
            setSelectedVariantName('');
            setisOpenMake(true);
            makeRef.current?.focus();
        }
    };

    const fetchMakeData = async (selectedYear) => {
        if (selectedYear) {
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getMakeByYear/${selectedYear}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        setDataMake(response.data);
                        setIsLoaderMake(true);
                        if (selectedYear && selectedMake) {
                            fetchModelData(selectedYear, selectedMake);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoaderMake(true);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoaderMake(true);
            }
        }
    };

    const handleMakeChange = (event) => {
        setisOpenVarient(false);
        const selectedMake = event.value;
        const selectedMakeName = event.label;
        setSelectedMake(selectedMake);
        setSelectedMakeName(selectedMakeName);
        setisOpenMake(false);

        setDataModel([]);
        setSelectedModel('');
        setSelectedVariant('');

        setIsLoaderModel(false);
        fetchModelData(selectedYear, selectedMake);
        setShowModel(true);
        setisOpenModel(true);
        setSelectedModelName('');
        setSelectedVariantName('');
        modelRef.current?.focus();
    };

    const fetchModelData = async (selectedYear, selectedMake) => {
        if (selectedYear && selectedMake) {
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getModelByMake/${selectedYear}/${selectedMake}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        setDataModel(response.data);
                        setIsLoaderModel(true);
                        if (selectedYear && selectedModel) {
                            fetchVariantData(selectedYear, selectedModel);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoaderModel(true);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoaderModel(true);
            }
        }
    };

    const handleModelChange = (event) => {
        setisOpenModel(false);
        setisOpenVarient(false);

        const selectedModel = event.value;
        const selectedModelName = event.label;
        setSelectedModel(selectedModel);
        setSelectedModelName(selectedModelName);
        setSelectedVariant('');
        setSelectedVariantName('');

        fetchVariantData(selectedYear, selectedModel);
        setIsLoaderVarient(false);
        setShowVarient(true);
        setisOpenVarient(true);
        variantRef.current?.focus();
    };

    const fetchVariantData = async (selectedYear, selectedModel) => {
        if (selectedYear && selectedModel) {
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getSubModelByModel/${selectedYear}/${selectedModel}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        setDataVarient(response.data);
                        setIsLoaderVarient(true);
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoaderVarient(true);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoaderVarient(true);
            }
        }
    };

    const handleVarientChange = (event) => {
        setisOpenVarient(false);
        const selectedVarient = event.value;
        const selectedVarientName = event.label;
        setSelectedVariant(selectedVarient);
        setSelectedVariantName(selectedVarientName);
    };

    const isOptionSelected = (option) => {
        if (!selectedVariant) return false;
        return (
            selectedVariant === option.value &&
            selectedVariantName.toLowerCase() === option.label.toLowerCase()
        );
    };

    const handleCloseModal = () => {
        setSelectedMakeName(vehicalDetails ? vehicalDetails.make_name : "Make");
        setSelectedModelName(vehicalDetails ? vehicalDetails.model_name : "Model");
        setSelectedVariantName(vehicalDetails ? vehicalDetails.variant_name : "Sub model");
        setShowVehicleModal(false);
        setisOpenMake(false);
        setisOpenModel(false);
        setisOpenVarient(false);
    };

    const showDropWDown = (value) => {
        if (isValue == value) {
            setIsValue(0)
        } else {
            setIsValue(value)
        }

    }

    const emptyLocalStorage = () => {

        localStorage.removeItem('setSelectedFitmentType');
        localStorage.removeItem('selectedCategories');
        localStorage.removeItem('selectedCategoriesName');
        localStorage.removeItem('selectedBrands');
        localStorage.removeItem('selectedBrandsName');
        localStorage.removeItem('setWheelOffsetArray');
        localStorage.removeItem('setColourWheel');
        localStorage.removeItem('setStockWheel');
        localStorage.removeItem('setDiameterArray');
        localStorage.removeItem('setWidthArray');
        localStorage.removeItem('setPatternArray');
        localStorage.removeItem('setBradArray');
        localStorage.removeItem('setBradNameArray');
        localStorage.removeItem('setcategoryArray');
        localStorage.removeItem('setcategoryNameArray');
        localStorage.removeItem('setModelArray');
        localStorage.removeItem('setMaxPrice');
        localStorage.removeItem('setMinPrice');
        localStorage.removeItem('setFirstValue');
        localStorage.removeItem('setSecondValue');
        localStorage.removeItem('setSpeedLoadRange');
        localStorage.removeItem('setSpeedRatingArray');
        localStorage.removeItem('setratioArray');
        localStorage.removeItem('setPlyArray');
        localStorage.removeItem('setSideWallArray');
        localStorage.removeItem('setMilageRatingArray');
        localStorage.removeItem('setRunFlat');
        localStorage.removeItem('setstuddable');
        localStorage.removeItem('settiresizes');
        localStorage.removeItem('setIsChecked');
        localStorage.removeItem('setIsCheckedStock');
        localStorage.removeItem('setSortingValue');
        localStorage.removeItem('setoffsetCurrentPage');
        localStorage.removeItem('setCurrentPage');
        localStorage.removeItem('inProductPage');


        localStorage.removeItem('setWheelSelectedFitmentType');
        localStorage.removeItem('WheelselectedCategories');
        localStorage.removeItem('WheelselectedCategoriesName');
        localStorage.removeItem('WheelselectedBrands');
        localStorage.removeItem('WheelselectedBrandsName');
        localStorage.removeItem('setWheelWheelOffsetArray');
        localStorage.removeItem('setWheelColourWheel');
        localStorage.removeItem('setWheelStockWheel');
        localStorage.removeItem('setWheelDiameterArray');
        localStorage.removeItem('setWheelWidthArray');
        localStorage.removeItem('setWheelPatternArray');
        localStorage.removeItem('setWheelBradArray');
        localStorage.removeItem('setWheelBradNameArray');
        localStorage.removeItem('setWheelcategoryArray');
        localStorage.removeItem('setWheelcategoryNameArray');
        localStorage.removeItem('setWheelModelArray');
        localStorage.removeItem('setWheelMaxPrice');
        localStorage.removeItem('setWheelMinPrice');
        localStorage.removeItem('setWheelFirstValue');
        localStorage.removeItem('setWheelSecondValue');
        localStorage.removeItem('setWheelIsChecked');
        localStorage.removeItem('setWheelIsCheckedStock');
        localStorage.removeItem('setWheelSortingValue');
        localStorage.removeItem('setWheeloffsetCurrentPage');
        localStorage.removeItem('setWheelCurrentPage');

        localStorage.removeItem('setWheelsSelectedFitmentType');
        localStorage.removeItem('setWheelsWheelOffsetArray');
        localStorage.removeItem('setWheelsColourWheel');
        localStorage.removeItem('setWheelsStockWheel');
        localStorage.removeItem('setWheelsDiameterArray');
        localStorage.removeItem('setWheelsWidthArray');
        localStorage.removeItem('setWheelsPatternArray');
        localStorage.removeItem('setWheelsBradArray');
        localStorage.removeItem('setWheelsBradNameArray');
        localStorage.removeItem('setWheelscategoryArray');
        localStorage.removeItem('setWheelscategoryNameArray');
        localStorage.removeItem('setWheelsModelArray');
        localStorage.removeItem('setWheelsMaxPrice');
        localStorage.removeItem('setWheelsMinPrice');
        localStorage.removeItem('setWheelsFirstValue');
        localStorage.removeItem('setWheelsSecondValue');
        localStorage.removeItem('setWheelsIsChecked');
        localStorage.removeItem('setWheelsIsCheckedStock');
        localStorage.removeItem('setWheelsSortingValue');
        localStorage.removeItem('setWheelsoffsetCurrentPage');
        localStorage.removeItem('setWheelsCurrentPage');



        localStorage.removeItem('setSwheelsSelectedFitmentType');
        localStorage.removeItem('setSwheelsWheelOffsetArray');
        localStorage.removeItem('setSwheelsColourWheel');
        localStorage.removeItem('setSwheelsStockWheel');
        localStorage.removeItem('setSwheelsDiameterArray');
        localStorage.removeItem('setSwheelsWidthArray');
        localStorage.removeItem('setSwheelsPatternArray');
        localStorage.removeItem('setSwheelsBradArray');
        localStorage.removeItem('setSwheelsBradNameArray');
        localStorage.removeItem('setSwheelscategoryArray');
        localStorage.removeItem('setSwheelscategoryNameArray');
        localStorage.removeItem('setSwheelsModelArray');
        localStorage.removeItem('setSwheelsMaxPrice');
        localStorage.removeItem('setSwheelsMinPrice');
        localStorage.removeItem('setSwheelsFirstValue');
        localStorage.removeItem('setSwheelsSecondValue');
        localStorage.removeItem('setSwheelsIsChecked');
        localStorage.removeItem('setSwheelsIsCheckedStock');
        localStorage.removeItem('setSwheelsSortingValue');
        localStorage.removeItem('setSwheelsoffsetCurrentPage');
        localStorage.removeItem('setSwheelsCurrentPage');

        //Rough Country
        localStorage.removeItem('rough_inStockOnly');
        localStorage.removeItem('rough_manufacturers');
        localStorage.removeItem('rough_categories');
        localStorage.removeItem('rough_lifts');
        localStorage.removeItem('rough_sortingValue');
        localStorage.removeItem('rough_currentPage');
        localStorage.removeItem('rough_offset');

        localStorage.removeItem('packages_selectedFitmentType');


    }


    const redirectToWheelPage = () => {
        const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';

        if (selectedYear) {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}`,
                headers: {
                    'FG-ApiKey': apiKey
                }
            };

            axios.request(config)
                .then((response) => {
                    let staggered = false;
                    let fmkWithStaggered = null;
                    // Find the object with isStaggered: true and get its fmk
                    for (const obj of response.data.result) {
                        if (obj.isStaggered === true) {
                            fmkWithStaggered = obj.fmk;
                            staggered = true;
                            break; // Break the loop once we find the first object with isStaggered: true
                        }
                    }

                    // If no object has isStaggered: true, get the fmk from the first object in the array
                    if (fmkWithStaggered === null && response.data.result.length > 0) {
                        fmkWithStaggered = response.data.result[0].fmk;
                    }

                    if (staggered) {
                        navigate(`/wheels-search-by-vehical/staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);
                    } else {
                        navigate(`/wheels-search-by-vehical?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });



        } else {
            setTimeout(() => {
                navigate(`/wheels`);
            }, 1000);
        }

    }

    const redirectToWheelAndTirePackage = async () => {
        if (selectedYear && selectedMake && selectedModel) {

            const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
            const variantName = vehicalDetails?.variant_name;

            const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';

            try {
                // 1. Get DriveTypeId from your backend
                const driveTypeResponse = await axios.get(
                    `${mainUrl}/api/getDriveTypeId`,
                    {
                        params: {
                            year: selectedYear,
                            make: selectedMake,
                            model: selectedModel,
                            variant: selectedVariant,
                            variantName: variantName || ""
                        }
                    }
                );

                const driveTypeId = driveTypeResponse.data?.driveTypeId || "";

                // 2. Call FitmentAtlas with DriveTypeId
                const config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}&DriveTypeId=${driveTypeId}`,
                    headers: {
                        'FG-ApiKey': apiKey
                    }
                };
                const response = await axios.request(config);

                let staggered = false;
                let fmkWithStaggered = null;

                // Check staggered setup
                for (const obj of response.data.result) {
                    if (obj.isStaggered === true) {
                        staggered = true;
                        fmkWithStaggered = obj.fmk;
                        break;
                    }
                }

                // Fallback first FMK
                if (
                    !fmkWithStaggered &&
                    response.data.result.length > 0
                ) {
                    fmkWithStaggered = response.data.result[0].fmk;
                }

                // No FMK found
                if (!fmkWithStaggered) {
                    navigate('/wheel-tire-packages');
                    return;
                }


                // 3. Get vehicle details
                const config2 = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/${fmkWithStaggered}`,
                    headers: {
                        'FG-ApiKey': apiKey
                    }
                };

                const response2 = await axios.request(config2);

                const vehicleData = response2.data.result;

                const vehicleType =
                    vehicleData?.vehicleTypeName || "";

                const liftedOptions =
                    vehicleData?.vehicleChassis?.vehicleLiftedSizes || [];


                // 4. Staggered vehicle
                if (staggered) {
                    navigate(
                        `/wheel-tire-packages/staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`
                    );
                    return;
                }


                // 5. Lifted truck
                if (
                    vehicleType === 'Truck' &&
                    liftedOptions.length > 0
                ) {
                    navigate(
                        `/wheel-tire-packages/lifted?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`
                    );
                    return;
                }


                // 6. Default
                navigate(
                    `/wheel-tire-packages?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`
                );

            } catch (error) {
                console.log(error);
                // navigate('/wheel-tire-packages');
            }

        } else {
            // No vehicle selected
        }
    };


    return (
        <div>
            {/* <!-- navigation-section start --> */}
            <section>
                <nav className={`navigation-bar ${showMenuSide}`} id="side-bar">
                    <div className="container">
                        <div className="crose" id="close-bar">
                            <button onClick={hideSideMenueBar}>
                                <img src="/images/x-mark.svg" alt="img" height="100%" width="100%" />
                            </button>
                        </div>
                        <ul className="navigation-list p-0 m-0">
                            <li className='ligt-main has-child' >

                                <span onClick={() => showDropWDown(1)}> Interior  <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 1 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">

                                                <li><a href="/products/22" onClick={emptyLocalStorage} >Gauges & Pods</a></li>
                                                <li><a href="/products/33" onClick={emptyLocalStorage}>Interior Accessories</a></li>
                                                <li><a href="/products/36" onClick={emptyLocalStorage}>Safety</a></li>
                                                <li><a href="/products/1" onClick={emptyLocalStorage}>Floor Mats</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </li>
                            <li className="main-menu-1 has-child" >
                                <span onClick={() => showDropWDown(2)}> Exterior  <i className="fa fa-caret-down"></i> </span>
                                <div className={`mega-menu ${isValue == 2 ? 'active-child' : ""}`}>
                                    <div className="col-lg-12 menu-iteam">
                                        <ul className="p-0 menu-list-mega">
                                            <li><a href="/products/14" onClick={emptyLocalStorage}>Bumpers, Grilles & Guards</a></li>
                                            <li><a href="/products/34" onClick={emptyLocalStorage}>Deflectors</a></li>
                                            <li><a href="/products/4" onClick={emptyLocalStorage}>Exterior Styling</a></li>
                                            <li><a href="/products/17" onClick={emptyLocalStorage}>Nerf Bars & Running Boards</a></li>
                                            <li><a href="/products/9" onClick={emptyLocalStorage}>Roofs & Roof Parts</a></li>
                                            <li><a href="/products/7" onClick={emptyLocalStorage}>Tonneau Covers</a></li>
                                            <li><a href="/products/5" onClick={emptyLocalStorage}>Truck Bed Accessories</a></li>
                                            <li><a href="/products/2" onClick={emptyLocalStorage}>Winches & Hitches</a></li>
                                            <li><a href="/products/13" onClick={emptyLocalStorage}>Fender Flares & Trim</a></li>
                                            <li><a href="/products/10" onClick={emptyLocalStorage}>Body Armor & Protection</a></li>
                                            {/* <li><a href="/products/49" onClick={emptyLocalStorage}>Grille Guards & Bull Bars</a></li> */}
                                            {/* <li><a href="/products/50" onClick={emptyLocalStorage}>Roof Racks & Truck Racks</a></li> */}
                                            {/* <li><a href="/products/47" onClick={emptyLocalStorage}>Truck Bed Liners</a></li> */}
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className='main-menu-1 has-child' >

                                <span onClick={() => showDropWDown(3)}> Performance  <i className="fa fa-caret-down"></i> </span>
                                <div className={`mega-menu ${isValue == 3 ? 'active-child' : ""}`}>
                                    <div className="col-lg-12 menu-iteam">
                                        <ul className="p-0 menu-list-mega">
                                            <li><a href="/products/32" onClick={emptyLocalStorage}>Brakes, Rotors & Pads</a></li>
                                            <li><a href="/products/30" onClick={emptyLocalStorage}>Cooling</a></li>
                                            <li><a href="/products/16" onClick={emptyLocalStorage}>Drivetrain</a></li>
                                            <li><a href="/products/12" onClick={emptyLocalStorage}>Engine Components</a></li>
                                            <li><a href="/products/27" onClick={emptyLocalStorage}>Exhaust, Mufflers & Tips</a></li>
                                            <li><a href="/products/20" onClick={emptyLocalStorage}>Fuel Delivery</a></li>
                                            <li><a href="/products/23" onClick={emptyLocalStorage}>Ignition</a></li>
                                            <li><a href="/products/29" onClick={emptyLocalStorage}>Oils & Oil Filters</a></li>
                                            <li><a href="/products/24" onClick={emptyLocalStorage}>Programmers & Chips</a></li>
                                            <li><a href="/products/21" onClick={emptyLocalStorage}>Suspension</a></li>
                                            <li><a href="/products/25" onClick={emptyLocalStorage}>Air Filters</a></li>
                                            <li><a href="/products/26" onClick={emptyLocalStorage}>Air Intake Systems</a></li>
                                            <li><a href="/products/36" onClick={emptyLocalStorage}>Safety</a></li>
                                            <li><a href="/products/18" onClick={emptyLocalStorage}>Forced Induction</a></li>
                                        </ul>
                                    </div>
                                </div>



                            </li>
                            <li className="ligt-main has-child" >

                                <span onClick={() => showDropWDown(4)}> Lighting  <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 4 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                <li><a href="/products/11" onClick={emptyLocalStorage}>Lights</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="wheel-mega-main has-child">
                                <span onClick={() => showDropWDown(5)}> Wheels & Tires  <i className="fa fa-caret-down"></i> </span>
                                <div className={`wheel-mega-menu mega-menu  ${isValue == 5 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                {/* <li onClick={redirectToWheelPage} style={{ cursor: 'pointer' }}>Wheels</li> */}
                                                <li><a href="/wheels" onClick={emptyLocalStorage}>Wheels</a></li>
                                                <li><a href="/tires" onClick={emptyLocalStorage}>Tires</a></li>
                                                <li><a href="/products/8" onClick={emptyLocalStorage}>Wheel and Tire Accessories</a></li>
                                                <li onClick={handleWheelAndTirePackageClick} className="wheel-tire-item">Wheel And Tire Packages</li>

                                                {/* <li><a href="/premium_wheels" onClick={emptyLocalStorage}>Premium Wheels</a></li> */}
                                                {/* <li><a href="/premium_tires" onClick={emptyLocalStorage}>Premium Tires</a></li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="ligt-main has-child" >
                                <span onClick={() => showDropWDown(6)}> Parts  <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 6 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                <li><a href="/products/25" onClick={emptyLocalStorage}>Air Filters</a></li>
                                                <li><a href="/products/26" onClick={emptyLocalStorage}>Air Intake Systems</a></li>
                                                <li><a href="/products/31" onClick={emptyLocalStorage}>Batteries, Starting & Charging</a></li>
                                                <li><a href="/products/32" onClick={emptyLocalStorage}>Brakes, Rotors & Pads</a></li>
                                                <li><a href="/products/30" onClick={emptyLocalStorage}>Cooling</a></li>
                                                {/* <li><a href="/products/34" onClick={emptyLocalStorage}>Deflectors</a></li> */}
                                                <li><a href="/products/16" onClick={emptyLocalStorage}>Drivetrain</a></li>
                                                <li><a href="/products/12" onClick={emptyLocalStorage}>Engine Components</a></li>
                                                <li><a href="/products/27" onClick={emptyLocalStorage}>Exhaust, Mufflers & Tips</a></li>
                                                <li><a href="/products/20" onClick={emptyLocalStorage}>Fuel Delivery</a></li>
                                                <li><a href="/products/23" onClick={emptyLocalStorage}>Ignition</a></li>
                                                <li><a href="/products/21" onClick={emptyLocalStorage}>Suspension</a></li>
                                                <li><a href="/products/15" onClick={emptyLocalStorage}>Fabrication</a></li>
                                                <li><a href="/products/18" onClick={emptyLocalStorage}>Forced Induction</a></li>
                                                <li><a href="/products/2" onClick={emptyLocalStorage}>Winches & Hitches</a></li>
                                                <li><a href="/products/uncategorized/custom_products" onClick={emptyLocalStorage}>Custom Products</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>


                            <li className="ligt-main has-child">
                                <span onClick={() => showDropWDown(7)}>Body Parts  <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 7 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                {/* <li><a href="/products/48" onClick={emptyLocalStorage}>Bumpers</a></li> */}
                                                <li><a href="/products/14" onClick={emptyLocalStorage}>Bumpers, Grilles & Guards</a></li>
                                                <li><a href="/products/34" onClick={emptyLocalStorage}>Deflectors</a></li>
                                                <li><a href="/products/4" onClick={emptyLocalStorage}>Exterior Styling</a></li>
                                                <li><a href="/products/13" onClick={emptyLocalStorage}>Fender Flares & Trim</a></li>
                                                <li><a href="/products/17" onClick={emptyLocalStorage}>Nerf Bars & Running Boards</a></li>
                                                <li><a href="/products/9" onClick={emptyLocalStorage}>Roofs & Roof Parts</a></li>
                                                <li><a href="/products/7" onClick={emptyLocalStorage}>Tonneau Covers</a></li>
                                                <li><a href="/products/5" onClick={emptyLocalStorage}>Truck Bed Parts</a></li>
                                                {/* <li><a href="/products/49" onClick={emptyLocalStorage}>Grille Guards & Bull Bars</a></li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>


                            {/* <li className="ligt-main has-child">
                                <span onClick={() => showDropWDown(10)}>Rough Country <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 10 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                <li><a href="/rough-country" onClick={emptyLocalStorage}>Rough Country</a></li> </ul>
                                        </div>
                                    </div>
                                </div>
                            </li> */}

                            <li className="ligt-main has-child">
                                {/* <span onClick={() => window.location.href = '/rough-country'}>Rough Country</span> */}
                                <span><a href="/rough-country" onClick={emptyLocalStorage}>Rough Country</a></span>

                                <span></span>
                            </li>

                            {/* <li className="ligt-main has-child">
                                <span onClick={() => showDropWDown(8)}>Financing <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 8 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                <li>
                                                    <a href="/financing" onClick={emptyLocalStorage}>Financing</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li> */}

                            <li className="ligt-main has-child">
                                {/* <span onClick={() => window.location.href = '/financing'}>Financing</span> */}

                                <span><a href="/financing" onClick={emptyLocalStorage}>Financing</a></span>
                            </li>


                            {/* <li className="ligt-main has-child">
                                <span onClick={() => showDropWDown(9)}>Specials <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 9 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                <li><a href="https://extremeperformance.com/wordpress/product/gift-card-2/" onClick={emptyLocalStorage}>Gift Cards</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li> */}

                            {/* <li><a href="#"> Financing </a></li> */}


                            <li className="ligt-main has-child">
                                <span onClick={() => showDropWDown(11)}>TECH CENTER <i className="fa fa-caret-down"></i> </span>
                                <div className={`light-mega mega-menu  ${isValue == 11 ? 'active-child' : ""}`}>
                                    <div className="row">
                                        <div className="col-lg-12 menu-iteam">
                                            <ul className="p-0 menu-list-mega">
                                                <li>
                                                    <a href="/wheel-torque-chart" onClick={emptyLocalStorage}>WHEEL TORQUE CHART</a>
                                                    <a href="/lug-nut-torque-chart" onClick={emptyLocalStorage}>LUG NUT TORQUE CHART</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>


                        </ul>
                    </div>
                </nav>


                <Modal show={showVehicleModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Select Your Vehicle</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mian-inner-data-tab position-relative">
                            <div className='selectMainDivEditPopup'>
                                Year
                                <Select
                                    options={dataYear.data}
                                    onChange={handleYearChange}
                                    placeholder='Year'
                                    value={selectedYear ? { value: selectedYear, label: selectedYear } : null}
                                    isSearchable={false}
                                />
                                {!isLoading ? "" : <div className="loader"></div>}
                            </div>

                            <div className='selectMainDivEditPopup'>
                                Make
                                <Select
                                    menuIsOpen={isOpenMake}
                                    options={dataMake.data}
                                    onChange={handleMakeChange}
                                    openMenuOnClick={true}
                                    placeholder='Make'
                                    value={selectedMake ? { value: selectedMake, label: selectedMakeName } : null}
                                    onMenuOpen={() => setisOpenMake(true)}
                                    onMenuClose={() => setisOpenMake(false)}
                                    isSearchable={false}
                                    ref={makeRef}
                                />
                                {isLoaderMake ? "" : <div className="loaderMake"></div>}
                            </div>

                            <div className='selectMainDivEditPopup'>
                                Model
                                <Select
                                    menuIsOpen={isOpenModel}
                                    options={dataModel.data}
                                    onChange={handleModelChange}
                                    openMenuOnClick={true}
                                    placeholder='Model'
                                    value={selectedModel ? { value: selectedModel, label: selectedModelName } : null}
                                    onMenuOpen={() => setisOpenModel(true)}
                                    onMenuClose={() => setisOpenModel(false)}
                                    isSearchable={false}
                                    ref={modelRef}
                                />
                                {isLoaderModel ? "" : <div className="loaderModel"></div>}
                            </div>

                            <div className='selectMainDivEditPopup'>
                                Sub Model
                                <Select
                                    menuIsOpen={isOpenVarient}
                                    options={dataModelVarient.data}
                                    onChange={handleVarientChange}
                                    openMenuOnClick={true}
                                    // placeholder='Varient'
                                    placeholder='Sub Model'
                                    value={selectedVariant ? { value: selectedVariant, label: selectedVariantName } : null}
                                    onMenuOpen={() => setisOpenVarient(true)}
                                    onMenuClose={() => setisOpenVarient(false)}
                                    isOptionSelected={isOptionSelected}
                                    isSearchable={false}
                                    ref={variantRef}
                                />
                                {isLoaderVarient ? "" : <div className="loaderVarient"></div>}
                            </div>

                            {!selectedModel ? (
                                <div className="text-right" style={{ textAlign: 'right' }}>
                                    <button className="btn btn-sm btn-danger m-2" disabled>

                                        <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                fill="white"></path>
                                            <path
                                                d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                fill="white"></path>
                                            <path
                                                d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                fill="white"></path>
                                            <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                fill="white"></path>
                                            <path
                                                d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                fill="white"></path>
                                            <path
                                                d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                fill="white"></path>
                                            <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                fill="white"></path>
                                            <path
                                                d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                fill="white"></path>
                                            <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                fill="white"></path>
                                            <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                fill="white"></path>
                                            <path
                                                d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                fill="white"></path>
                                        </svg>
                                        Search Packages
                                    </button>
                                </div>
                            ) : (
                                <div className="text-right" style={{ textAlign: 'right' }}>
                                    <button className="btn btn btn-danger srch_btn m-2 " onClick={handleVehicleSearch} >

                                        <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                fill="white"></path>
                                            <path
                                                d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                fill="white"></path>
                                            <path
                                                d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                fill="white"></path>
                                            <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                fill="white"></path>
                                            <path
                                                d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                fill="white"></path>
                                            <path
                                                d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                fill="white"></path>
                                            <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                fill="white"></path>
                                            <path
                                                d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                fill="white"></path>
                                            <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                fill="white"></path>
                                            <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                fill="white"></path>
                                            <path
                                                d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                fill="white"></path>
                                        </svg>
                                        <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="img" width="100%" height="100%" />
                                        Search Packages
                                    </button>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                </Modal>

            </section>
            {/* <!-- navigation-section end --> */}
        </div>
    )
}











// import { React, useState, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import Modal from 'react-bootstrap/Modal';
// import Select from "react-select";



// export default function Menubar(prop) {
//     const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
//     const navigate = useNavigate();
//     const { showMenuSide, setValueMenuSideBar } = prop;

//     const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
//     const variantName = vehicalDetails?.variant_name;

//     const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "");
//     const [selectedMake, setSelectedMake] = useState(vehicalDetails ? vehicalDetails.make : "");
//     const [selectedMakeName, setSelectedMakeName] = useState(vehicalDetails ? vehicalDetails.make_name : "");
//     const [selectedModel, setSelectedModel] = useState(vehicalDetails ? vehicalDetails.model : "");
//     const [selectedModelName, setSelectedModelName] = useState(vehicalDetails ? vehicalDetails.model_name : "");
//     const [selectedVariant, setSelectedVariant] = useState(vehicalDetails ? vehicalDetails.variant : "");
//     const [selectedVariantName, setSelectedVariantName] = useState(vehicalDetails ? vehicalDetails.variant_name : "");


//     const [isActive, setIsActvie] = useState('');
//     const [isValue, setIsValue] = useState('');

//     const [showVehicleModal, setShowVehicleModal] = useState(false);

//     const [dataYear, setDataYear] = useState([]);
//     const [dataMake, setDataMake] = useState([]);
//     const [dataModel, setDataModel] = useState([]);
//     const [dataModelVarient, setDataVarient] = useState([]);



//     const hideSideMenueBar = () => {
//         setValueMenuSideBar('')
//         document.body.classList.remove('home-layout');
//     }

//     useEffect(() => {
//         fetchYearData();
//     }, []);


//     const handleWheelAndTirePackageClick = () => {
//         emptyLocalStorage();
//         const vehicle = JSON.parse(localStorage.getItem('vehical_details'));
//         if (vehicle && vehicle.year && vehicle.make && vehicle.model) {
//             redirectToWheelAndTirePackage();
//         } else {
//             setShowVehicleModal(true);
//         }
//     };

//     const handleVehicleSearch = () => {
//         if (!selectedYear || !selectedMake || !selectedModel) {
//             return;
//         }
//         const vehicleData = {
//             year: selectedYear,
//             make: selectedMake,
//             make_name: selectedMakeName,
//             model: selectedModel,
//             model_name: selectedModelName,
//             variant: selectedVariant,
//             variant_name: selectedVariantName
//         };

//         localStorage.setItem('vehical_details', JSON.stringify(vehicleData));
//         setShowVehicleModal(false);
//         redirectToWheelAndTirePackage();
//     };


//     const fetchYearData = async () => {
//         try {
//             let config = {
//                 method: 'get',
//                 maxBodyLength: Infinity,
//                 url: `${mainUrl}/api/getYear`,
//             };
//             axios
//                 .request(config)
//                 .then((response) => {
//                     setDataYear(response.data);
//                     if (selectedYear) {
//                         fetchMakeData(selectedYear);
//                     }

//                 })
//                 .catch((error) => {
//                     console.log(error);
//                 });
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };

//     const handleYearChange = (event) => {
//         const selectedYear = event.value
//         if (selectedYear === "") {
//             setSelectedMake('');
//             setSelectedModel('');
//             setSelectedVariant('');
//             setDataMake("")
//             setDataModel("")
//             setDataVarient("")

//             setSelectedMakeName('')
//             setSelectedModelName('')
//             setSelectedVariantName('')
//         } else {
//             setSelectedYear(selectedYear);
//             setSelectedMake('');
//             setSelectedModel('');
//             setSelectedVariant('');
//             fetchMakeData(selectedYear);
//             setSelectedMakeName('')
//             setSelectedModelName('')
//             setSelectedVariantName('')
//         }

//     };

//     const fetchMakeData = async (selectedYear) => {
//         if (selectedYear) {
//             try {
//                 let config = {
//                     method: 'get',
//                     maxBodyLength: Infinity,
//                     url: `${mainUrl}/api/getMakeByYear/${selectedYear}`,
//                 };
//                 axios
//                     .request(config)
//                     .then((response) => {
//                         setDataMake(response.data);

//                         if (selectedYear && selectedMake) {
//                             fetchModelData(selectedYear, selectedMake);
//                         }

//                     })
//                     .catch((error) => {
//                         console.log(error);
//                     });
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         }
//     };

//     const handleMakeChange = (event) => {
//         const selectedMake = event.value;
//         const selectedMakeName = event.label;
//         setSelectedMake(selectedMake);
//         setSelectedMakeName(selectedMakeName);

//         setDataModel([]);
//         setSelectedModel('');
//         setSelectedVariant('');

//         fetchModelData(selectedYear, selectedMake);
//         setSelectedModelName('')
//         setSelectedVariantName('')
//     };

//     const fetchModelData = async (selectedYear, selectedMake) => {
//         if (selectedYear && selectedMake) {
//             try {
//                 let config = {
//                     method: 'get',
//                     maxBodyLength: Infinity,
//                     url: `${mainUrl}/api/getModelByMake/${selectedYear}/${selectedMake}`,
//                 };
//                 axios
//                     .request(config)
//                     .then((response) => {
//                         setDataModel(response.data);
//                         if (selectedYear && selectedModel) {
//                             fetchVariantData(selectedYear, selectedModel);
//                         }

//                     })
//                     .catch((error) => {
//                         console.log(error);
//                     });
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         }
//     };

//     const handleModelChange = (event) => {
//         const selectedModel = event.value;
//         const selectedModelName = event.label;
//         setSelectedModel(selectedModel);
//         setSelectedModelName(selectedModelName);
//         setSelectedVariant('');
//         setSelectedVariantName('')
//         // Fetch variant data based on selected year, make, and model
//         fetchVariantData(selectedYear, selectedModel);
//     };

//     const fetchVariantData = async (selectedYear, selectedModel) => {
//         if (selectedYear && selectedModel) {
//             try {
//                 let config = {
//                     method: 'get',
//                     maxBodyLength: Infinity,
//                     url: `${mainUrl}/api/getSubModelByModel/${selectedYear}/${selectedModel}`,
//                 };
//                 axios
//                     .request(config)
//                     .then((response) => {
//                         setDataVarient(response.data);
//                     })
//                     .catch((error) => {
//                         console.log(error);
//                     });
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         }
//     };

//     const handleVarientChange = (event) => {
//         const selectedVarient = event.value;
//         const selectedVarientName = event.label
//         setSelectedVariant(selectedVarient);
//         setSelectedVariantName(selectedVarientName);

//     };




//     const showDropWDown = (value) => {
//         if (isValue == value) {
//             setIsValue(0)
//         } else {
//             setIsValue(value)
//         }

//     }

//     const emptyLocalStorage = () => {

//         localStorage.removeItem('setSelectedFitmentType');
//         localStorage.removeItem('selectedCategories');
//         localStorage.removeItem('selectedCategoriesName');
//         localStorage.removeItem('selectedBrands');
//         localStorage.removeItem('selectedBrandsName');
//         localStorage.removeItem('setWheelOffsetArray');
//         localStorage.removeItem('setColourWheel');
//         localStorage.removeItem('setStockWheel');
//         localStorage.removeItem('setDiameterArray');
//         localStorage.removeItem('setWidthArray');
//         localStorage.removeItem('setPatternArray');
//         localStorage.removeItem('setBradArray');
//         localStorage.removeItem('setBradNameArray');
//         localStorage.removeItem('setcategoryArray');
//         localStorage.removeItem('setcategoryNameArray');
//         localStorage.removeItem('setModelArray');
//         localStorage.removeItem('setMaxPrice');
//         localStorage.removeItem('setMinPrice');
//         localStorage.removeItem('setFirstValue');
//         localStorage.removeItem('setSecondValue');
//         localStorage.removeItem('setSpeedLoadRange');
//         localStorage.removeItem('setSpeedRatingArray');
//         localStorage.removeItem('setratioArray');
//         localStorage.removeItem('setPlyArray');
//         localStorage.removeItem('setSideWallArray');
//         localStorage.removeItem('setMilageRatingArray');
//         localStorage.removeItem('setRunFlat');
//         localStorage.removeItem('setstuddable');
//         localStorage.removeItem('settiresizes');
//         localStorage.removeItem('setIsChecked');
//         localStorage.removeItem('setIsCheckedStock');
//         localStorage.removeItem('setSortingValue');
//         localStorage.removeItem('setoffsetCurrentPage');
//         localStorage.removeItem('setCurrentPage');
//         localStorage.removeItem('inProductPage');


//         localStorage.removeItem('setWheelSelectedFitmentType');
//         localStorage.removeItem('WheelselectedCategories');
//         localStorage.removeItem('WheelselectedCategoriesName');
//         localStorage.removeItem('WheelselectedBrands');
//         localStorage.removeItem('WheelselectedBrandsName');
//         localStorage.removeItem('setWheelWheelOffsetArray');
//         localStorage.removeItem('setWheelColourWheel');
//         localStorage.removeItem('setWheelStockWheel');
//         localStorage.removeItem('setWheelDiameterArray');
//         localStorage.removeItem('setWheelWidthArray');
//         localStorage.removeItem('setWheelPatternArray');
//         localStorage.removeItem('setWheelBradArray');
//         localStorage.removeItem('setWheelBradNameArray');
//         localStorage.removeItem('setWheelcategoryArray');
//         localStorage.removeItem('setWheelcategoryNameArray');
//         localStorage.removeItem('setWheelModelArray');
//         localStorage.removeItem('setWheelMaxPrice');
//         localStorage.removeItem('setWheelMinPrice');
//         localStorage.removeItem('setWheelFirstValue');
//         localStorage.removeItem('setWheelSecondValue');
//         localStorage.removeItem('setWheelIsChecked');
//         localStorage.removeItem('setWheelIsCheckedStock');
//         localStorage.removeItem('setWheelSortingValue');
//         localStorage.removeItem('setWheeloffsetCurrentPage');
//         localStorage.removeItem('setWheelCurrentPage');

//         localStorage.removeItem('setWheelsSelectedFitmentType');
//         localStorage.removeItem('setWheelsWheelOffsetArray');
//         localStorage.removeItem('setWheelsColourWheel');
//         localStorage.removeItem('setWheelsStockWheel');
//         localStorage.removeItem('setWheelsDiameterArray');
//         localStorage.removeItem('setWheelsWidthArray');
//         localStorage.removeItem('setWheelsPatternArray');
//         localStorage.removeItem('setWheelsBradArray');
//         localStorage.removeItem('setWheelsBradNameArray');
//         localStorage.removeItem('setWheelscategoryArray');
//         localStorage.removeItem('setWheelscategoryNameArray');
//         localStorage.removeItem('setWheelsModelArray');
//         localStorage.removeItem('setWheelsMaxPrice');
//         localStorage.removeItem('setWheelsMinPrice');
//         localStorage.removeItem('setWheelsFirstValue');
//         localStorage.removeItem('setWheelsSecondValue');
//         localStorage.removeItem('setWheelsIsChecked');
//         localStorage.removeItem('setWheelsIsCheckedStock');
//         localStorage.removeItem('setWheelsSortingValue');
//         localStorage.removeItem('setWheelsoffsetCurrentPage');
//         localStorage.removeItem('setWheelsCurrentPage');



//         localStorage.removeItem('setSwheelsSelectedFitmentType');
//         localStorage.removeItem('setSwheelsWheelOffsetArray');
//         localStorage.removeItem('setSwheelsColourWheel');
//         localStorage.removeItem('setSwheelsStockWheel');
//         localStorage.removeItem('setSwheelsDiameterArray');
//         localStorage.removeItem('setSwheelsWidthArray');
//         localStorage.removeItem('setSwheelsPatternArray');
//         localStorage.removeItem('setSwheelsBradArray');
//         localStorage.removeItem('setSwheelsBradNameArray');
//         localStorage.removeItem('setSwheelscategoryArray');
//         localStorage.removeItem('setSwheelscategoryNameArray');
//         localStorage.removeItem('setSwheelsModelArray');
//         localStorage.removeItem('setSwheelsMaxPrice');
//         localStorage.removeItem('setSwheelsMinPrice');
//         localStorage.removeItem('setSwheelsFirstValue');
//         localStorage.removeItem('setSwheelsSecondValue');
//         localStorage.removeItem('setSwheelsIsChecked');
//         localStorage.removeItem('setSwheelsIsCheckedStock');
//         localStorage.removeItem('setSwheelsSortingValue');
//         localStorage.removeItem('setSwheelsoffsetCurrentPage');
//         localStorage.removeItem('setSwheelsCurrentPage');

//         //Rough Country
//         localStorage.removeItem('rough_inStockOnly');
//         localStorage.removeItem('rough_manufacturers');
//         localStorage.removeItem('rough_categories');
//         localStorage.removeItem('rough_lifts');
//         localStorage.removeItem('rough_sortingValue');

//         localStorage.removeItem('packages_selectedFitmentType');


//     }


//     const redirectToWheelPage = () => {
//         const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';

//         if (selectedYear) {
//             let config = {
//                 method: 'get',
//                 maxBodyLength: Infinity,
//                 url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}`,
//                 headers: {
//                     'FG-ApiKey': apiKey
//                 }
//             };

//             axios.request(config)
//                 .then((response) => {
//                     let staggered = false;
//                     let fmkWithStaggered = null;
//                     // Find the object with isStaggered: true and get its fmk
//                     for (const obj of response.data.result) {
//                         if (obj.isStaggered === true) {
//                             fmkWithStaggered = obj.fmk;
//                             staggered = true;
//                             break; // Break the loop once we find the first object with isStaggered: true
//                         }
//                     }

//                     // If no object has isStaggered: true, get the fmk from the first object in the array
//                     if (fmkWithStaggered === null && response.data.result.length > 0) {
//                         fmkWithStaggered = response.data.result[0].fmk;
//                     }

//                     if (staggered) {
//                         navigate(`/wheels-search-by-vehical/staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);
//                     } else {
//                         navigate(`/wheels-search-by-vehical?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant}`);
//                     }
//                 })
//                 .catch((error) => {
//                     console.log(error);
//                 });



//         } else {
//             setTimeout(() => {
//                 navigate(`/wheels`);
//             }, 1000);
//         }

//     }


//     // const redirectToWheelAndTirePackage = () => {
//     //     if (selectedYear && selectedMake && selectedModel) {
//     //         const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';

//     //         let config = {
//     //             method: 'get',
//     //             maxBodyLength: Infinity,
//     //             url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}`,
//     //             headers: {
//     //                 'FG-ApiKey': apiKey
//     //             }
//     //         };

//     //         axios.request(config)
//     //             .then((response) => {
//     //                 let staggered = false;
//     //                 let fmkWithStaggered = null;

//     //                 // Check staggered setup
//     //                 for (const obj of response.data.result) {
//     //                     if (obj.isStaggered === true) {
//     //                         staggered = true;
//     //                         fmkWithStaggered = obj.fmk;
//     //                         break;
//     //                     }
//     //                 }

//     //                 // Fallback first FMK
//     //                 if (!fmkWithStaggered && response.data.result.length > 0) {
//     //                     fmkWithStaggered = response.data.result[0].fmk;
//     //                 }

//     //                 // No FMK found
//     //                 if (!fmkWithStaggered) {
//     //                     navigate('/wheel-tire-packages');
//     //                     return;
//     //                 }

//     //                 // Get vehicle details
//     //                 let config2 = {
//     //                     method: 'get',
//     //                     maxBodyLength: Infinity,
//     //                     url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/${fmkWithStaggered}`,
//     //                     headers: {
//     //                         'FG-ApiKey': apiKey
//     //                     }
//     //                 };

//     //                 axios.request(config2)
//     //                     .then((response2) => {
//     //                         const vehicleData = response2.data.result;
//     //                         const vehicleType = vehicleData?.vehicleTypeName || '';
//     //                         const liftedOptions = vehicleData?.vehicleChassis?.vehicleLiftedSizes || [];

//     //                         // Staggered vehicle
//     //                         if (staggered) {
//     //                             navigate(`/wheel-tire-packages/staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`);
//     //                             return;
//     //                         }

//     //                         // Lifted truck
//     //                         if (vehicleType === 'Truck' && liftedOptions.length > 0) {
//     //                             navigate(`/wheel-tire-packages/lifted?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`);
//     //                             return;
//     //                         }
//     //                         navigate(`/wheel-tire-packages?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`);
//     //                     })
//     //                     .catch((error) => {
//     //                         console.log(error);
//     //                         // navigate('/wheel-tire-packages');
//     //                     });

//     //             })
//     //             .catch((error) => {
//     //                 console.log(error);
//     //                 navigate('/wheel-tire-packages');
//     //             });

//     //     } else {
//     //         // navigate('/wheel-tire-packages');

//     //     }
//     // };

//     const redirectToWheelAndTirePackage = async () => {
//         if (selectedYear && selectedMake && selectedModel) {

//             const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
//             const variantName = vehicalDetails?.variant_name;

//             const apiKey = 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE';

//             try {
//                 // 1. Get DriveTypeId from your backend
//                 const driveTypeResponse = await axios.get(
//                     `${mainUrl}/api/getDriveTypeId`,
//                     {
//                         params: {
//                             year: selectedYear,
//                             make: selectedMake,
//                             model: selectedModel,
//                             variant: selectedVariant || "",
//                             variantName: variantName || ""
//                         }
//                     }
//                 );

//                 const driveTypeId = driveTypeResponse.data?.driveTypeId || "";

//                 // 2. Call FitmentAtlas with DriveTypeId
//                 const config = {
//                     method: 'get',
//                     maxBodyLength: Infinity,
//                     url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${selectedYear}&MakeId=${selectedMake}&ModelId=${selectedModel}&ProductType=wheel&SubmodelID=${selectedVariant}&DriveTypeId=${driveTypeId}`,
//                     headers: {
//                         'FG-ApiKey': apiKey
//                     }
//                 };

//                 const response = await axios.request(config);

//                 let staggered = false;
//                 let fmkWithStaggered = null;

//                 // Check staggered setup
//                 for (const obj of response.data.result) {
//                     if (obj.isStaggered === true) {
//                         staggered = true;
//                         fmkWithStaggered = obj.fmk;
//                         break;
//                     }
//                 }

//                 // Fallback first FMK
//                 if (
//                     !fmkWithStaggered &&
//                     response.data.result.length > 0
//                 ) {
//                     fmkWithStaggered = response.data.result[0].fmk;
//                 }

//                 // No FMK found
//                 if (!fmkWithStaggered) {
//                     navigate('/wheel-tire-packages');
//                     return;
//                 }


//                 // 3. Get vehicle details
//                 const config2 = {
//                     method: 'get',
//                     maxBodyLength: Infinity,
//                     url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/${fmkWithStaggered}`,
//                     headers: {
//                         'FG-ApiKey': apiKey
//                     }
//                 };

//                 const response2 = await axios.request(config2);
//                 const vehicleData = response2.data.result;
//                 const vehicleType = vehicleData?.vehicleTypeName || "";
//                 const liftedOptions = vehicleData?.vehicleChassis?.vehicleLiftedSizes || [];


//                 // 4. Staggered vehicle
//                 if (staggered) {
//                     navigate(`/wheel-tire-packages/staggered?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`);
//                     return;
//                 }


//                 // 5. Lifted truck
//                 if (
//                     vehicleType === 'Truck' &&
//                     liftedOptions.length > 0
//                 ) {
//                     navigate(`/wheel-tire-packages/lifted?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`);
//                     return;
//                 }


//                 // 6. Default
//                 navigate(`/wheel-tire-packages?year=${selectedYear}&make=${selectedMake}&model=${selectedModel}&variant=${selectedVariant || ''}`);

//             } catch (error) {
//                 console.log(error);
//                 // navigate('/wheel-tire-packages');
//             }

//         } else {
//             // No vehicle selected
//         }
//     };

//     return (
//         <div>
//             {/* <!-- navigation-section start --> */}
//             <section>
//                 <nav className={`navigation-bar ${showMenuSide}`} id="side-bar">
//                     <div className="container">
//                         <div className="crose" id="close-bar">
//                             <button onClick={hideSideMenueBar}>
//                                 <img src="/images/x-mark.svg" alt="img" height="100%" width="100%" />
//                             </button>
//                         </div>
//                         <ul className="navigation-list p-0 m-0">
//                             <li className='ligt-main has-child' >

//                                 <span onClick={() => showDropWDown(1)}> Interior  <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 1 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">

//                                                 <li><a href="/products/22" onClick={emptyLocalStorage} >Gauges & Pods</a></li>
//                                                 <li><a href="/products/33" onClick={emptyLocalStorage}>Interior Accessories</a></li>
//                                                 <li><a href="/products/36" onClick={emptyLocalStorage}>Safety</a></li>
//                                                 <li><a href="/products/1" onClick={emptyLocalStorage}>Floor Mats</a></li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>

//                             </li>
//                             <li className="main-menu-1 has-child" >
//                                 <span onClick={() => showDropWDown(2)}> Exterior  <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`mega-menu ${isValue == 2 ? 'active-child' : ""}`}>
//                                     <div className="col-lg-12 menu-iteam">
//                                         <ul className="p-0 menu-list-mega">
//                                             <li><a href="/products/14" onClick={emptyLocalStorage}>Bumpers, Grilles & Guards</a></li>
//                                             <li><a href="/products/34" onClick={emptyLocalStorage}>Deflectors</a></li>
//                                             <li><a href="/products/4" onClick={emptyLocalStorage}>Exterior Styling</a></li>
//                                             <li><a href="/products/17" onClick={emptyLocalStorage}>Nerf Bars & Running Boards</a></li>
//                                             <li><a href="/products/9" onClick={emptyLocalStorage}>Roofs & Roof Parts</a></li>
//                                             <li><a href="/products/7" onClick={emptyLocalStorage}>Tonneau Covers</a></li>
//                                             <li><a href="/products/5" onClick={emptyLocalStorage}>Truck Bed Accessories</a></li>
//                                             <li><a href="/products/2" onClick={emptyLocalStorage}>Winches & Hitches</a></li>
//                                             <li><a href="/products/13" onClick={emptyLocalStorage}>Fender Flares & Trim</a></li>
//                                             <li><a href="/products/10" onClick={emptyLocalStorage}>Body Armor & Protection</a></li>
//                                             {/* <li><a href="/products/49" onClick={emptyLocalStorage}>Grille Guards & Bull Bars</a></li>
//                                             <li><a href="/products/50" onClick={emptyLocalStorage}>Roof Racks & Truck Racks</a></li>
//                                             <li><a href="/products/47" onClick={emptyLocalStorage}>Truck Bed Liners</a></li> */}
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </li>
//                             <li className='main-menu-1 has-child' >

//                                 <span onClick={() => showDropWDown(3)}> Performance  <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`mega-menu ${isValue == 3 ? 'active-child' : ""}`}>
//                                     <div className="col-lg-12 menu-iteam">
//                                         <ul className="p-0 menu-list-mega">
//                                             <li><a href="/products/32" onClick={emptyLocalStorage}>Brakes, Rotors & Pads</a></li>
//                                             <li><a href="/products/30" onClick={emptyLocalStorage}>Cooling</a></li>
//                                             <li><a href="/products/16" onClick={emptyLocalStorage}>Drivetrain</a></li>
//                                             <li><a href="/products/12" onClick={emptyLocalStorage}>Engine Components</a></li>
//                                             <li><a href="/products/27" onClick={emptyLocalStorage}>Exhaust, Mufflers & Tips</a></li>
//                                             <li><a href="/products/20" onClick={emptyLocalStorage}>Fuel Delivery</a></li>
//                                             <li><a href="/products/23" onClick={emptyLocalStorage}>Ignition</a></li>
//                                             <li><a href="/products/29" onClick={emptyLocalStorage}>Oils & Oil Filters</a></li>
//                                             <li><a href="/products/24" onClick={emptyLocalStorage}>Programmers & Chips</a></li>
//                                             <li><a href="/products/21" onClick={emptyLocalStorage}>Suspension</a></li>
//                                             <li><a href="/products/25" onClick={emptyLocalStorage}>Air Filters</a></li>
//                                             <li><a href="/products/26" onClick={emptyLocalStorage}>Air Intake Systems</a></li>
//                                             <li><a href="/products/36" onClick={emptyLocalStorage}>Safety</a></li>
//                                             <li><a href="/products/18" onClick={emptyLocalStorage}>Forced Induction</a></li>
//                                         </ul>
//                                     </div>
//                                 </div>



//                             </li>
//                             <li className="ligt-main has-child" >

//                                 <span onClick={() => showDropWDown(4)}> Lighting  <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 4 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 <li><a href="/products/11" onClick={emptyLocalStorage}>Lights</a></li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li>
//                             <li className="wheel-mega-main has-child">
//                                 <span onClick={() => showDropWDown(5)}> Wheels & Tires  <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`wheel-mega-menu mega-menu  ${isValue == 5 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 {/* <li onClick={redirectToWheelPage} style={{ cursor: 'pointer' }}>Wheels</li> */}
//                                                 <li><a href="/wheels" onClick={emptyLocalStorage}>Wheels</a></li>
//                                                 <li><a href="/tires" onClick={emptyLocalStorage}>Tires</a></li>
//                                                 <li><a href="/products/8" onClick={emptyLocalStorage}>Wheel and Tire Accessories</a></li>
//                                                 <li onClick={handleWheelAndTirePackageClick} className="wheel-tire-item">Wheel And Tire Packages</li>

//                                                 {/* <li><a href="/premium_wheels" onClick={emptyLocalStorage}>Premium Wheels</a></li> */}
//                                                 {/* <li><a href="/premium_tires" onClick={emptyLocalStorage}>Premium Tires</a></li> */}
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li>
//                             <li className="ligt-main has-child" >
//                                 <span onClick={() => showDropWDown(6)}> Parts  <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 6 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 <li><a href="/products/25" onClick={emptyLocalStorage}>Air Filters</a></li>
//                                                 <li><a href="/products/26" onClick={emptyLocalStorage}>Air Intake Systems</a></li>
//                                                 <li><a href="/products/31" onClick={emptyLocalStorage}>Batteries, Starting & Charging</a></li>
//                                                 <li><a href="/products/32" onClick={emptyLocalStorage}>Brakes, Rotors & Pads</a></li>
//                                                 <li><a href="/products/30" onClick={emptyLocalStorage}>Cooling</a></li>
//                                                 <li><a href="/products/34" onClick={emptyLocalStorage}>Deflectors</a></li>
//                                                 <li><a href="/products/16" onClick={emptyLocalStorage}>Drivetrain</a></li>
//                                                 <li><a href="/products/12" onClick={emptyLocalStorage}>Engine Components</a></li>
//                                                 <li><a href="/products/27" onClick={emptyLocalStorage}>Exhaust, Mufflers & Tips</a></li>
//                                                 <li><a href="/products/20" onClick={emptyLocalStorage}>Fuel Delivery</a></li>
//                                                 <li><a href="/products/23" onClick={emptyLocalStorage}>Ignition</a></li>
//                                                 <li><a href="/products/21" onClick={emptyLocalStorage}>Suspension</a></li>
//                                                 <li><a href="/products/15" onClick={emptyLocalStorage}>Fabrication</a></li>
//                                                 <li><a href="/products/18" onClick={emptyLocalStorage}>Forced Induction</a></li>
//                                                 <li><a href="/products/2" onClick={emptyLocalStorage}>Winches & Hitches</a></li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li>


//                             <li className="ligt-main has-child">
//                                 <span onClick={() => showDropWDown(7)}>Body Parts  <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 7 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 {/* <li><a href="/products/48" onClick={emptyLocalStorage}>Bumpers</a></li> */}
//                                                 <li><a href="/products/14" onClick={emptyLocalStorage}>Bumpers, Grilles & Guards</a></li>
//                                                 <li><a href="/products/34" onClick={emptyLocalStorage}>Deflectors</a></li>
//                                                 <li><a href="/products/4" onClick={emptyLocalStorage}>Exterior Styling</a></li>
//                                                 <li><a href="/products/13" onClick={emptyLocalStorage}>Fender Flares & Trim</a></li>
//                                                 <li><a href="/products/17" onClick={emptyLocalStorage}>Nerf Bars & Running Boards</a></li>
//                                                 <li><a href="/products/9" onClick={emptyLocalStorage}>Roofs & Roof Parts</a></li>
//                                                 <li><a href="/products/7" onClick={emptyLocalStorage}>Tonneau Covers</a></li>
//                                                 <li><a href="/products/5" onClick={emptyLocalStorage}>Truck Bed Parts</a></li>
//                                                 {/* <li><a href="/products/49" onClick={emptyLocalStorage}>Grille Guards & Bull Bars</a></li> */}
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li>


//                             {/* <li className="ligt-main has-child">
//                                 <span onClick={() => showDropWDown(10)}>Rough Country <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 10 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 <li><a href="/rough-country" onClick={emptyLocalStorage}>Rough Country</a></li> </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li> */}

//                             <li className="ligt-main has-child">
//                                 <span onClick={() => window.location.href = '/rough-country'}>Rough Country</span>
//                             </li>

//                             {/* <li className="ligt-main has-child">
//                                 <span onClick={() => showDropWDown(8)}>Financing <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 8 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 <li>
//                                                     <a href="/financing" onClick={emptyLocalStorage}>Financing</a>
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li> */}

//                             <li className="ligt-main has-child">
//                                 <span onClick={() => window.location.href = '/financing'}>Financing</span>
//                             </li>


//                             {/* <li className="ligt-main has-child">
//                                 <span onClick={() => showDropWDown(9)}>Specials <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 9 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 <li><a href="https://extremeperformance.com/wordpress/product/gift-card-2/" onClick={emptyLocalStorage}>Gift Cards</a></li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li> */}

//                             {/* <li><a href="#"> Financing </a></li> */}


//                             <li className="ligt-main has-child">
//                                 <span onClick={() => showDropWDown(11)}>TECH CENTER <i className="fa fa-caret-down"></i> </span>
//                                 <div className={`light-mega mega-menu  ${isValue == 11 ? 'active-child' : ""}`}>
//                                     <div className="row">
//                                         <div className="col-lg-12 menu-iteam">
//                                             <ul className="p-0 menu-list-mega">
//                                                 <li>
//                                                     <a href="/wheel-torque-chart" onClick={emptyLocalStorage}>WHEEL TORQUE CHART</a>
//                                                     <a href="/lug-nut-torque-chart" onClick={emptyLocalStorage}>LUG NUT TORQUE CHART</a>
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li>


//                         </ul>
//                     </div>
//                 </nav>


//                 <Modal show={showVehicleModal} onHide={() => setShowVehicleModal(false)}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Select Vehicle</Modal.Title>
//                     </Modal.Header>

//                     <Modal.Body>
//                         <div className="selectMainDivEditPopup">
//                             Year
//                             <Select
//                                 options={dataYear.data}
//                                 onChange={handleYearChange}
//                                 placeholder="Year"
//                                 value={selectedYear ? {
//                                     value: selectedYear,
//                                     label: selectedYear
//                                 } : null}
//                             />
//                         </div>

//                         <div className="selectMainDivEditPopup">
//                             Make
//                             <Select
//                                 options={dataMake.data}
//                                 onChange={handleMakeChange}
//                                 placeholder="Make"
//                                 value={selectedMake ? {
//                                     value: selectedMake,
//                                     label: selectedMakeName
//                                 } : null}
//                             />
//                         </div>

//                         <div className="selectMainDivEditPopup">
//                             Model
//                             <Select
//                                 options={dataModel.data}
//                                 onChange={handleModelChange}
//                                 placeholder="Model"
//                                 value={selectedModel ? {
//                                     value: selectedModel,
//                                     label: selectedModelName
//                                 } : null}
//                             />
//                         </div>

//                         <div className="selectMainDivEditPopup">
//                             Sub Model
//                             <Select
//                                 options={dataModelVarient.data}
//                                 onChange={handleVarientChange}
//                                 placeholder="Sub Model"
//                                 value={selectedVariant ? {
//                                     value: selectedVariant,
//                                     label: selectedVariantName
//                                 } : null}
//                             />
//                         </div>

//                         <div className="text-end mt-3">
//                             <button
//                                 className="btn btn btn-danger srch_btn m-2"
//                                 onClick={handleVehicleSearch}
//                                 disabled={!selectedYear || !selectedMake || !selectedModel}
//                             >
//                                 <svg width="32" height="23" viewBox="0 0 32 23" fill="none" style={{ marginRight: "8px" }} xmlns="http://www.w3.org/2000/svg">
//                                     <path
//                                         d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
//                                         fill="white"></path>
//                                     <path
//                                         d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
//                                         fill="white"></path>
//                                     <path
//                                         d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
//                                         fill="white"></path>
//                                     <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
//                                         fill="white"></path>
//                                     <path
//                                         d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
//                                         fill="white"></path>
//                                     <path
//                                         d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
//                                         fill="white"></path>
//                                     <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
//                                         fill="white"></path>
//                                     <path
//                                         d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
//                                         fill="white"></path>
//                                     <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
//                                         fill="white"></path>
//                                     <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
//                                         fill="white"></path>
//                                     <path
//                                         d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
//                                         fill="white"></path>
//                                 </svg>

//                                 Search Packages
//                             </button>

//                         </div>

//                         {/* <div className="text-end mt-3">
//                             <button
//                                 className="btn btn-danger srch_btn m-2"
//                                 onClick={handleVehicleSearch}
//                                 disabled={!selectedYear || !selectedMake || !selectedModel} >
//                                 Search Packages
//                             </button>
//                         </div> */}


//                     </Modal.Body>
//                 </Modal>

//             </section>
//             {/* <!-- navigation-section end --> */}
//         </div>
//     )
// }








